import { apiFetchWithRetry } from './apiFetch';

/**
 * Employer domains the automated lookup couldn't settle.
 *
 * A domain reaches this queue only when the web-grounded check was
 * inconclusive — a real business with a thin web presence looks the same to a
 * search as one that doesn't exist, so the system asks rather than guesses.
 */
export interface OrganizationQueueItem {
  id: string;
  domain: string;
  name: string | null;
  website: string | null;
  summary: string | null;
  country: string | null;
  /** 0-1. Low means the lookup found something but wasn't sure. */
  confidence: number | null;
  lookupNote: string | null;
  checkedAt: string | null;
  /** Endorsements blocked on this domain — what makes one row urgent. */
  pendingHypes: number;
  /** What students said the organisation was. A consistency check. */
  statedOrganizations: string[];
}

export const organizationService = {
  listQueue: async (): Promise<{ items: OrganizationQueueItem[] }> => {
    const response = await apiFetchWithRetry('/v1/admin/organizations/queue');
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data?.message || 'Failed to load the employer queue');
    return data as { items: OrganizationQueueItem[] };
  },

  decide: async (domain: string, confirm: boolean, note?: string): Promise<{ status: string; promoted: number }> => {
    const response = await apiFetchWithRetry(`/v1/admin/organizations/${encodeURIComponent(domain)}/decide`, {
      method: 'POST',
      body: JSON.stringify({ confirm, note }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data?.message || "Couldn't record that decision");
    return data as { status: string; promoted: number };
  },
};
